import { SUPER_CROPS } from './constants';
import organizerData from './fixtures.json';
import { OrganizerCardProps } from './OrganizerCard';

export const ORGANIZER_CARD_DEFAULT_PROPS: Omit<
    OrganizerCardProps,
    'handleFollow'
> = {
    ...organizerData,
    organizerName: organizerData.name,
    organizerUrl: organizerData.url,
    imageUrl: organizerData.image_url,
    subtitle: `${organizerData.num_followers} followers`,
    isFollowing: organizerData.followed_by_you,
};

export const getRandomSuperCrop = () => {
    const ranIdx = Math.floor(Math.random() * (SUPER_CROPS.length - 1));
    return SUPER_CROPS[ranIdx];
};
